module.exports = __webpack_public_path__ + "img/2020051115484920200511154106.a5eb6fbd.png";